import { createSelector } from 'reselect';
import { TEventDetailsState } from './types';

/*
 * eventUserRegistration:
 */

const eventUserRegistrationState = (state: any) => state?.eventDetails as TEventDetailsState;

export const requestPendingSelector = createSelector(eventUserRegistrationState, (state) => state.requestPending);

export const eventUserRegistrationFormSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventRegistrationForm
);

export const eventUserRegistrationMultiRegistrationEventsSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventRegistrationForm?.multiRegistrationEvents
);

export const isLoadingEventUserRegistrationSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventRegistrationDetails.isLoading
);

export const eventUserRegistrationSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventRegistrationDetails.details
);

export const eventUserRegistrationUISelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventRegistrationDetails.ui
);

export const eventUserRegistrationMinTeamSizeSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventRegistrationDetails.details?.minTeamSize
);

export const eventUserRegistrationMaxTeamSizeSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventRegistrationDetails.details?.maxTeamSize
);

export const isLoadedEventUserRegistrationSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventRegistrationDetails.isLoaded
);

export const isLoadingEventTeamListSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventTeamList.isLoading
);

export const eventTeamListSelector = createSelector(eventUserRegistrationState, (state) => state.eventTeamList.list);

export const isLoadedEventTeamListSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventTeamList.isLoaded
);

export const eventTeamListUISelector = createSelector(eventUserRegistrationState, (state) => state.eventTeamList.ui);

export const isLoadingEventReminderListSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventReminderList.isLoading
);

export const isLoadedEventReminderListSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventReminderList.isLoaded
);

export const eventReminderListSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventReminderList.list
);

export const eventReminderListUISelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventReminderList.ui
);

export const isRefreshingEventReminderListSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.eventReminderList.isRefreshing
);

export const eventBracketListSelector = createSelector(eventUserRegistrationState, (state) => state.eventBracketList);

export const eventBracketDetailsSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.selectedEventBracketDetails
);

export const teamRankingsIsRefreshingSelector = createSelector(
  // TODO: add type
  (state: any) => state?.keystoneTeamRankings,
  // TODO: add type
  (state: any) => state.isRefreshing
);

export const loadableBracketSelector = createSelector(eventUserRegistrationState, (state) => state.dynamic);

export const isCheckingInRequestPendingSelector = createSelector(
  eventUserRegistrationState,
  (state) => state.isCheckingInRequestPending
);
